import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr } from "@/utils/utils";
import 'ol/ol.css';
import { Map, View } from 'ol';
import ol from 'ol';
import { GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { getVectorContext } from 'ol/render';
import StyleFill from 'ol/style/Fill';
import Overlay from 'ol/Overlay';
import StyleStroke from 'ol/style/Stroke';
import { defaults } from 'ol/control';
import Projection from 'ol/proj/Projection';
import LayerImage from 'ol/layer/Image';
import SourceImagestatic from 'ol/source/ImageStatic';
import StyleIcon from 'ol/style/Icon';
import Attribution from 'ol/control/Attribution';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import StyleText from 'ol/style/Text';
import provincesCoordinate from './data.json';
import axios from 'axios';
export default {
  name: 'threeMap',
  meta: {
    title: '公共文化手绘地图'
  },
  data() {
    return {
      baseVector: '',
      //大地图
      provinceVector: '',
      //省份地图
      tabs: ['非遗地图', '文化地图', '文旅地图', '文博地图', '行迹地图'],
      activeTab: 0,
      mapDatas: [],
      point: '117.348611,40.581141',
      iconSource: '',
      iconLayer: '',
      drawsource: '',
      drawLayer: '',
      map: null,
      staticImageLayer: '',
      //静态省份地图图层
      provincesStaticLayer: [],
      pointByProvince: [],
      outerLayer: [],
      //地图阴影
      showProvinceMap: false,
      //显示省份详细地图
      positionsInProvince: [],
      //省份地图上的详细点
      iFrameUrl: '',
      isTouch: false,
      currentZoom: 4.5,
      bobyScale: 1,
      provincePositionImageLayers: [],
      //省份详细地图的静态们
      provinceSource: ''
    };
  },
  methods: {
    clearStyle(type, adcode) {
      var features = type == 'smallMap' ? this.provinceVector.getSource().getFeatures() : this.baseVector.getSource().getFeatures();
      // 递归一下数据
      if (!features || !features.length) {
        setTimeout(() => {
          this.clearStyle(type, adcode);
        }, 500);
        return;
      } else {
        let that = this;
        features.forEach(function (item) {
          let name = item.get('name');
          if (name == '中华人民共和国') return;
          if (that.pointByProvince.find(p => {
            return p.province == name;
          })) {
            console.log(name, '324');
            item.setStyle(new Style({
              stroke: new StyleStroke({
                color: '#FEBE5E',
                width: 1
              }),
              //填充色
              fill: new StyleFill({
                color: '#febe5e54'
                // color: 'rgba(0,0,0,0)'
              }),
              zIndex: 222
            }));
          } else {
            item.setStyle(new Style({
              //填充色
              fill: new StyleFill({
                color: that.getLineGradientStyle()
              }),
              stroke: new StyleStroke({
                color: '#62EBFF',
                width: 1
              }),
              zIndex: 221
            }));
          }
        });
      }
      if (!adcode) return;
      this.setPositionInProvince(adcode);
    },
    styleFunction(feature) {
      const styles = [
      // linestring
      new Style({
        stroke: new StyleStroke({
          // color: '#877d6a',
          width: 1,
          lineDash: [4, 2]
        })
      })];
      return styles;
    },
    getLineGradientStyle() {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const pixelRatio = 3;
      let gradient = context.createLinearGradient(0, 0, 1024 * pixelRatio, 0);
      let mainColor = '#141B36';
      let secondColor = '#0F477D';
      gradient.addColorStop(0, mainColor);
      gradient.addColorStop(0.2, secondColor);
      gradient.addColorStop(0.4, mainColor);
      gradient.addColorStop(0.6, secondColor);
      gradient.addColorStop(1, mainColor);
      return gradient;
    },
    // 边界阴影
    setBond3D() {
      let outerLayer = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: './mapDatas/100000.json'
        }),
        style: new Style({
          stroke: new StyleStroke({
            width: 10,
            color: '#0B76C1'
          }),
          fill: new StyleFill({
            color: 'rgba(255,0,0,0)'
          })
        }),
        zIndex: 3,
        opacity: 0.8,
        name: '背景1'
      });

      //outer
      let outerLayer2 = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: './mapDatas/100000.json'
        }),
        style: new Style({
          stroke: new StyleStroke({
            width: 20,
            color: '#095A94'
          }),
          fill: new StyleFill({
            color: 'rgba(255,0,0,0)'
          })
        }),
        zIndex: 3,
        opacity: 0.8,
        name: '背景2'
      });
      //outer
      let outerLayer3 = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: './mapDatas/100000.json'
        }),
        style: new Style({
          stroke: new StyleStroke({
            width: 30,
            color: '#054979'
          }),
          fill: new StyleFill({
            color: 'rgba(255,0,0,0)'
          })
        }),
        zIndex: 3,
        opacity: 0.8,
        name: '背景3'
      });
      this.outerLayer = [outerLayer, outerLayer2, outerLayer3];
      this.outerLayer.map(o => {
        this.map.addLayer(o);
      });
    },
    // 点击tab
    handelActiveTab(index) {
      this.pointByProvince = [];
      // 删除高亮样式
      this.clearStyle();
      // 删除点
      this.iconSource.clear();
      // 删除已有省份图层
      this.provincesStaticLayer.map(layer => {
        this.map.removeLayer(layer);
      });
      this.activeTab = index;
      this.getDatas();
      if (this.showProvinceMap) this.resetFullMap();
    },
    // 获取数据
    getDatas() {
      let params = {
        deptId: 186266,
        formId: '965338',
        page: 1,
        limit: 100,
        t: 'c0cb6c9009fba8090a35624b65f71464aa5084d3028db91d73d6a5f2391a6610'
      };
      let searchStr = {
        'model': 0,
        'filters': [[{
          'alias': '8',
          'compt': 'editinput',
          'express': '===',
          'val': this.tabs[this.activeTab]
        }]]
      };
      this.pointByProvince = [];
      params.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(params).then(res => {
        this.mapDatas = res.dataList.map((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
          item.province = itemformdata[10].groupValues[0].values[0][0] ? itemformdata[10].groupValues[0].values[0][0].val : '';
          item.adcode = provincesCoordinate[item.province].adcode;
          item.city = itemformdata[10].groupValues[0].values[0][1] ? itemformdata[10].groupValues[0].values[0][1].val : '';
          // 针对省份信息去重
          if (!this.pointByProvince.find(m => {
            return m.province == item.province;
          })) {
            this.pointByProvince.push(item);
          }
          return item;
        });
        console.log(this.mapDatas, 'mapDatas');
        this.clearStyle();
        this.setFeatureStyle(this.pointByProvince);
      });
    },
    setFeatureStyle(pointByProvince) {
      var allFeatures = this.baseVector.getSource().getFeatures();
      if (!allFeatures || !allFeatures.length) {
        return setTimeout(() => {
          this.setFeatureStyle(pointByProvince);
        }, 500);
      }
      pointByProvince.map(point => {
        // 点坐标
        let provinceData = provincesCoordinate[point.province];
        if (!provinceData) return;
        let coordinate = provinceData.coordinate;
        if (!coordinate) return;
        // 省份地图数量
        let mapNum = this.mapDatas.filter(m => {
          return m.province == point.province;
        });
        console.log(coordinate, mapNum.length, provinceData.adcode, point.province);
        this.createPoint(coordinate, mapNum.length, provinceData.adcode, point.province);
        // 省份地图显示
        // 新增选中的省份图层
        let extent = provinceData.extent;
        if (!extent) return;
        // allFeatures.forEach((feature) =>{
        //   if (feature.get('name') == point.province) {
        //     console.log(feature.get('name'), '324')
        //     feature.setStyle(
        //       new Style({
        //         stroke: new StyleStroke({
        //           color: '#FEBE5E',
        //           width: 2,
        //         }),
        //           //填充色
        //         fill: new StyleFill({
        //           color: '#febe5e54',
        //         }),
        //         zIndex: 222,
        //       })
        //     )
        //   }
        // })
        let staticImageLayer = this.getStaticImageLayer(extent, provinceData.adcode);
        this.provincesStaticLayer.push(staticImageLayer);
        this.map.addLayer(staticImageLayer);
      });
    },
    // coordinate 坐标点
    // text 坐标文字
    // adcode 区域
    // name 点位名称
    createPoint(coordinate, text, adcode, name) {
      console.log(adcode, 'adcode');
      let _this = this;
      let zoom = Math.round(this.map.getView().getZoom());
      let c = coordinate.split(',');
      let cX = Number(c[0]);
      let cY = adcode ? Number(c[1]) + 1 : Number(c[1]) - 0.03;
      let imgtextFeature = new Feature({
        geometry: new Point(fromLonLat([cX, cY])),
        name: name,
        xy: [cX, cY],
        adcode: adcode,
        text: text
      });
      // 处理点位文字
      let textstyle = '';
      textstyle = new StyleText({
        text: `${text}`,
        font: 'bold 16px Microsoft YaHei',
        fill: new StyleFill({
          color: '#fff'
        }),
        offsetY: -10,
        scale: this.bobyScale
      });
      // 处理点位图片
      let ispointImg = new StyleIcon({
        src: './images/icon.png',
        offset: [0, 0],
        // width: 10,
        scale: this.bobyScale * 0.4
      });
      imgtextFeature.setStyle(new Style({
        image: ispointImg,
        text: textstyle
      }));
      this.iconSource.addFeature(imgtextFeature);
    },
    // 加载静态地图
    getStaticImageLayer(extent, name, fileUrl, zIndex) {
      const imageExtent = transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
      const imageProjection = new Projection({
        code: 'xkcd-image',
        units: 'pixels',
        extent: imageExtent
      });
      let staticImageLayer = new LayerImage({
        source: new SourceImagestatic({
          attributions: '© <a href="https://xkcd.com/license.html">xkcd</a>',
          url: fileUrl ? fileUrl : `./map/${name}.png`,
          projection: imageProjection,
          imageExtent: imageExtent
        }),
        opacity: 1,
        className: 'static',
        zIndex: zIndex || 3
      });
      return staticImageLayer;
    },
    // 删除各种图层
    removeOtherLayer() {
      // 删除已有省份静态图层
      this.provincesStaticLayer.map(layer => {
        this.map.removeLayer(layer);
      });
      // 删除外侧阴影
      this.outerLayer.map(o => {
        this.map.removeLayer(o);
      });
      this.iconSource.clear();
    },
    // 重置全国地图
    resetFullMap() {
      // 删除省份详细地图
      this.map.removeLayer(this.provinceVector);
      this.showProvinceMap = false;

      // 重置外侧阴影
      this.outerLayer.map(o => {
        this.map.addLayer(o);
      });
      // 重置大地图
      this.map.addLayer(this.baseVector);
      this.map.getView().animate({
        center: transform([117.000923, 36.675807], 'EPSG:4326', 'EPSG:3857'),
        zoom: this.currentZoom
      });
    },
    //新增详细点
    setPositionInProvince(adcode) {
      let fullData;
      let currentCode;
      if (adcode == 120000 || adcode == 110000) currentCode = 100000;
      this.provincePositionImageLayers.map(item => {
        this.map.removeLayer(item);
      });
      this.provincePositionImageLayers = [];
      let citys = [];
      let that = this;
      axios.get(`./mapDatas/${currentCode || adcode}_full.json`).then(res => {
        //成功数据
        fullData = res.data.features || [];
        this.mapDatas.map(item => {
          let data = fullData.find(f => {
            return f.properties.name == item.city;
          });
          console.log(data, 'data');
          if (!data) return;
          let extent = provincesCoordinate[item.city] ? provincesCoordinate[item.city].extent : [];
          // 增加区域地图缩略
          let staticImageLayer = this.getStaticImageLayer(extent, '', item.itemformdata[7][0].fileUrl, 4);
          this.provincePositionImageLayers.push(staticImageLayer);
          citys.push({
            city: item.city,
            fileUrl: item.itemformdata[7][0].fileUrl
          });
          // 缩放到中心
          let newCenter = data.properties.center;
          if (item.adcode == adcode) {
            this.createPoint(`${newCenter[0]},${newCenter[1]}`, item.itemformdata[3], '', '详细地图');
          }
          // 贴图
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          var img = new Image(); // 创建一个<img>元素

          img.src = item.itemformdata[7][0].fileUrl;
          img.onload = function () {
            var pattern = ctx.createPattern(img, 'repeat');
            // console.log(ctx)
            that.changeProvinceVectorStyle(citys, pattern);
          };
        });

        // 修改选中地图的背景样式
      }).catch(err => {
        //请求失败数据
        console.log(err);
      });
    },
    changeProvinceVectorStyle(citys, pattern) {
      var features = this.provinceVector.getSource().getFeatures();
      if (!features || !features.length) {
        return setTimeout(() => {
          this.changeProvinceVectorStyle(citys, pattern);
        }, 500);
      }
      let that = this;
      // vector.setStyle(new ol.style.Style({
      //   stroke: new ol.style.Stroke({
      //     color: 'red',
      //     lineDash: [5],
      //     width: 2
      //   }),
      //   fill: new ol.style.Fill({
      //     color: pattern
      //   })
      // }));
      features.forEach(function (feature) {
        let name = feature.get('name');
        if (citys.find(c => {
          return c.city == name;
        })) {
          feature.setStyle(new Style({
            stroke: new StyleStroke({
              color: '#FEBE5E',
              width: 2
            }),
            //填充色
            fill: new StyleFill({
              color: pattern
            }),
            zIndex: 222
          }));
          let newFeature = feature.clone();
          newFeature.setStyle(new Style({
            //填充色
            fill: new StyleFill({
              color: '#febe5e38'
            }),
            // opacity: 0.2,
            zIndex: 222
          }));
          that.provinceSource.addFeature(newFeature);
        }
      });
      // this.provincePositionImageLayers.map((item)=>{
      //   this.map.addLayer(item)
      // })
    },
    setMap(staticlayer, coordinateData) {
      const geojsonObject = {
        'type': 'FeatureCollection',
        'crs': {
          'type': 'name',
          'properties': {
            'name': 'EPSG:3857'
          }
        },
        'features': [{
          'type': 'Feature',
          'geometry': {
            'type': 'Polygon',
            'coordinates': [coordinateData]
          }
        }]
      };
      const clipLayer = new VectorLayer({
        source: new VectorSource({
          // features: new GeoJSON().readFeatures(geojsonObject),
          format: new GeoJSON(),
          url: './mapDatas/140000_full.json'
        }),
        style: new Style({
          // stroke: new StyleStroke({
          //   color: '#333333',
          //   width: 1,
          // }),
          fill: new StyleFill({
            color: 'rgba(0, 0, 0, 0.4)'
          })
        })
        // opacity: 0.5
      });
      clipLayer.getSource().on('addfeature', function () {
        staticlayer.setExtent(clipLayer.getSource().getExtent());
      });
      staticlayer.on('postrender', function (e) {
        const vectorContext = getVectorContext(e);
        console.log(vectorContext, 'vectorContext');
        // e.context.globalCompositeOperation = 'destination-in'
        clipLayer.getSource().forEachFeature(function (feature) {
          vectorContext.drawFeature(feature, new Style({
            // fill: new StyleFill({
            //   color: 'rgba(0, 0, 0, 0.4)',
            // }),
            stroke: new StyleStroke({
              color: '#333333',
              width: 1
            })
          }));
        });
        setTimeout(() => {
          e.context.globalCompositeOperation = 'destination-in';
        }, 1000);
      });
      this.map = new Map({
        layers: [this.baseVector, staticlayer, clipLayer
        // this.drawLayer,
        ],
        logo: true,
        target: this.$refs.maps,
        view: new View({
          center: transform([106.3683244, 39.915085], 'EPSG:4326', 'EPSG:3857'),
          zoom: this.currentZoom
        }),
        controls: defaults({
          attribution: false
        })
      });
    }
  },
  mounted() {
    let that = this;
    this.baseVector = new VectorLayer({
      source: new VectorSource({
        format: new GeoJSON(),
        url: './mapDatas/100000_full.json'
      }),
      style: new Style({
        stroke: new StyleStroke({
          color: '#62EBFF',
          width: 1
        })
      }),
      zIndex: 4
    });
    // test
    this.drawsource = new VectorSource();
    this.drawLayer = new VectorLayer({
      source: this.drawsource,
      style: this.styleFunction
    });
    this.iconSource = new VectorSource();
    this.iconLayer = new VectorLayer({
      source: this.iconSource,
      zIndex: 30
    });
    const imagesextent = transformExtent([110.229584, 34.583368, 114.568877, 40.737314], 'EPSG:4326', 'EPSG:3857');
    const projection = new Projection({
      code: 'xkcd-image',
      units: 'pixels',
      extent: imagesextent
    });
    const staticlayer = new LayerImage({
      source: new SourceImagestatic({
        attributions: '© <a href="https://xkcd.com/license.html">xkcd</a>',
        url: './map/1400002.png',
        projection: projection,
        imageExtent: imagesextent
      })
      // zIndex: 5
    });
    let coordinateData = [];
    axios.get(`./mapDatas/140000_full.json`).then(res => {
      console.log(res);
      res = res.data;
      res.features[0].geometry.coordinates[0][0].forEach(function (item, index) {
        coordinateData.push(transform(item, 'EPSG:4326', 'EPSG:3857'));
      });
      that.setMap(staticlayer, coordinateData);
    });

    // 获取数据
    this.$nextTick(() => {
      // this.getDatas()
    });
    // this.setBond3D()
    let popoverlay;
    // 省份鼠标选种方法，隐藏
    let areaType = {
      province: 7,
      city: 9,
      district: 11
    };
    let currentRecord = [];
    // this.map.on('click', function(event) {
    //   // console.log(event)
    //   // console.log(event.coordinate)
    //   /* 获取指针所在的像素点 */
    //   var pixel = that.map.getEventPixel(event.originalEvent); 
    //   var feature;
    //   if (popoverlay) popoverlay.setPosition(undefined)
    //   /* 是否和地图交互 */
    //   let featureItem
    //   if (that.map.hasFeatureAtPixel(pixel)) {
    //     feature = that.map.forEachFeatureAtPixel(pixel, function (feature, layer) { return feature });
    //     featureItem = feature.values_
    //     currentRecord.push(featureItem)
    //   } else {
    //     if (currentRecord.length === 0) return
    //     featureItem = currentRecord[currentRecord.length - 1]
    //     if (typeof(featureItem.parent) === 'string') featureItem.parent = JSON.parse(featureItem.parent)
    //   }
    //   // 点击详细地图跳转
    //   if (featureItem.name == '详细地图') {
    //     console.log(that.mapDatas, featureItem.text)
    //     let iframeData = that.mapDatas.find((m) =>{return m.itemformdata[3] == featureItem.text})
    //     that.iFrameUrl = iframeData ? iframeData.itemformdata[6] : ''
    //     return
    //   }
    //   if (that.showProvinceMap) return
    //   let level = areaType[featureItem.level]
    //   let adcode = featureItem.adcode
    //   if (!adcode) return
    //   if (!that.mapDatas.find((data) =>{return data.adcode == adcode})) return
    //   let isFull = featureItem.childrenNum > 0 ? '_full' : ''
    //   if (!that.map.hasFeatureAtPixel(pixel)) {
    //     level = currentRecord.length >= 2 ? areaType[currentRecord[currentRecord.length - 2].level] : 5
    //     adcode = featureItem.parent.adcode
    //     isFull = currentRecord.length >= 2 ? (currentRecord[currentRecord.length - 2].childrenNum > 0 ? '_full' : '') : '_full'
    //   }
    //   that.map.removeLayer(that.baseVector)
    //   that.provinceSource = new VectorSource({
    //     format: new GeoJSON(),
    //     url: `./mapDatas/${adcode}_full.json`,
    //   })
    //   that.provinceVector = new VectorLayer({
    //     source: that.provinceSource,
    //     style: new Style({
    //       stroke: new StyleStroke({
    //         color: '#62EBFF',
    //         width: 1,
    //       })
    //     }),
    //     zIndex:2
    //   })
    //   !featureItem.center ? level = 7 : ''
    //   // 内蒙缩小
    //   adcode == 150000 ? level = 5 : ''
    //   that.showProvinceMap = true
    //   // 删除已有
    //   that.removeOtherLayer()
    //   // 新增地图详细点

    //   that.map.addLayer(that.provinceVector)
    //   that.clearStyle('smallMap', adcode)
    //   let center = featureItem.center || featureItem.xy
    //   var newCenter = fromLonLat(center)
    //   that.map.getView().animate({
    //     center: newCenter,
    //     zoom: that.bobyScale > 1 ? level + that.bobyScale * 0.6 : level
    //   })

    //   if (!that.map.hasFeatureAtPixel(pixel)) currentRecord = currentRecord.slice(0, -1)
    // })
    // this.map.on(('click'), function(evt){
    //   let coordinateArr = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
    //   console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6))
    // })
    // 地图监听 触摸事件 触摸开始
    let mapDom = document.querySelector('#map');
    mapDom.addEventListener('touchstart', e => {
      // 
      that.isTouch = true;
    });
    // 缩放地图 结束后事件
    // this.map.on('moveend', function(event) {
    //   if (that.isTouch) return
    //   // that.resolutionchange(event)
    // })
  },
  created() {
    if (document.body.clientWidth < 1920) return;
    this.bobyScale = document.body.clientWidth / 1920;
    this.currentZoom += this.bobyScale * 0.6;
  },
  computed: {}
};